<template>
  <div class="MatchSlide">
    <SlideHeading v-bind="{ content }" />
    <SlideBodyText v-if="variationBody" :blocks="variationBody" class="bodyText" />
  </div>
</template>

<script>
import SlideBodyText from './elems/SlideBodyText.vue'
import SlideHeading from './elems/SlideHeading.vue'

export default {
  components: {
    SlideBodyText,
    SlideHeading,
  },
  props: {
    content: Object,
    isCurrentSlide: Boolean,
    selectedOptions: Object,
    fieldConfig: Object,
    fieldValues: Object,
    fieldErrors: Object,
  },
  computed: {
    variationBody() {
      const selectedValue = this.selectedOptions[this.content.optionKey]
      const variation = (
        selectedValue
        && this.content.variations?.find(
          (variation) => variation.optionValue === selectedValue
        )
      )
      return variation?.body ?? this.content.defaultBody
    },
  },
}
</script>

<style scoped>

.MatchSlide {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.bodyText {
  margin-top: var(--spacing-4);
}
</style>
